import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA1Xj05368Khb7qEIMme6o-6XWddPdsrow",
  authDomain: "barberlys-492c4.firebaseapp.com",
  projectId: "barberlys-492c4",
  storageBucket: "barberlys-492c4.firebasestorage.app",
  messagingSenderId: "1001521404734",
  appId: "1:1001521404734:web:665c9b47b6a5fb0ec8ea6f",
  measurementId: "G-LVZPJ3V9BV",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyAjjhTOLoigqj87gGv 3rqJxK0Dpc1g29ls",
//   authDomain: "barberlys-993e0.firebaseapp.com",
//   projectId: "barberlys-993e0",
//   storageBucket: "barberlys-993e0.firebasestorage.app",
//   messagingSenderId: "1064611049556",
//   appId: "1:1064611049556:web:19ede5d573f5358036fdc1"
// };
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
